import React from 'react'
import Link from '../Link'
import * as styles from './index.module.css'

const ChildNavPlain = ({ url, label, subtitle, ctaText }) => {
  return (
    <Link
      className={!subtitle && !ctaText ? styles.childShrink : styles.childFlex}
      to={(url += url.endsWith('/') ? '' : '/')}
    >
      <div className={styles.container}>
        <div className={styles.descriptionBlock}>
          <div>
            {label && (
              <div
                className={[styles.label, ctaText ? styles.withCta : ''].join(
                  ' '
                )}
              >
                {label}
              </div>
            )}
          </div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {ctaText && (
            <div className={styles.ctaTextLink}>
              {ctaText}
              &nbsp;&nbsp;
              <svg
                width="7"
                height="12"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.667 6L0 1.2 1.167 0 7 6l-5.833 6L0 10.8 4.667 6z"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}

export default ChildNavPlain
